/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Ai_Agent_Development_Memory_Title6Inputs */

const en_svc_ai_agent_development_memory_title6 = /** @type {(inputs: Svc_Ai_Agent_Development_Memory_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Memory & context`)
};

const ar_svc_ai_agent_development_memory_title6 = /** @type {(inputs: Svc_Ai_Agent_Development_Memory_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الذاكرة والسياق`)
};

const bn_svc_ai_agent_development_memory_title6 = /** @type {(inputs: Svc_Ai_Agent_Development_Memory_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`মেমোরি ও কনটেক্সট`)
};

const de_svc_ai_agent_development_memory_title6 = /** @type {(inputs: Svc_Ai_Agent_Development_Memory_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erinnerung und Kontext`)
};

const es_svc_ai_agent_development_memory_title6 = /** @type {(inputs: Svc_Ai_Agent_Development_Memory_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Memoria y contexto`)
};

const fr_svc_ai_agent_development_memory_title6 = /** @type {(inputs: Svc_Ai_Agent_Development_Memory_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mémoire et contexte`)
};

const pt_svc_ai_agent_development_memory_title6 = /** @type {(inputs: Svc_Ai_Agent_Development_Memory_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Memória e contexto`)
};

const zh_svc_ai_agent_development_memory_title6 = /** @type {(inputs: Svc_Ai_Agent_Development_Memory_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`内存和上下文`)
};

const tr_svc_ai_agent_development_memory_title6 = /** @type {(inputs: Svc_Ai_Agent_Development_Memory_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bellek ve bağlam`)
};

const ru_svc_ai_agent_development_memory_title6 = /** @type {(inputs: Svc_Ai_Agent_Development_Memory_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Память и контекст`)
};

const pl_svc_ai_agent_development_memory_title6 = /** @type {(inputs: Svc_Ai_Agent_Development_Memory_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pamięć i kontekst`)
};

/**
* | output |
* | --- |
* | "Memory & context" |
*
* @param {Svc_Ai_Agent_Development_Memory_Title6Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_ai_agent_development_memory_title6 = /** @type {((inputs?: Svc_Ai_Agent_Development_Memory_Title6Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Ai_Agent_Development_Memory_Title6Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_ai_agent_development_memory_title6(inputs)
	if (locale === "bn") return bn_svc_ai_agent_development_memory_title6(inputs)
	if (locale === "de") return de_svc_ai_agent_development_memory_title6(inputs)
	if (locale === "es") return es_svc_ai_agent_development_memory_title6(inputs)
	if (locale === "fr") return fr_svc_ai_agent_development_memory_title6(inputs)
	if (locale === "pt") return pt_svc_ai_agent_development_memory_title6(inputs)
	if (locale === "zh") return zh_svc_ai_agent_development_memory_title6(inputs)
	if (locale === "tr") return tr_svc_ai_agent_development_memory_title6(inputs)
	if (locale === "ru") return ru_svc_ai_agent_development_memory_title6(inputs)
	if (locale === "pl") return pl_svc_ai_agent_development_memory_title6(inputs)
	return en_svc_ai_agent_development_memory_title6(inputs)
});
export { svc_ai_agent_development_memory_title6 as "svc_ai-agent-development_MEMORY_title" }